/**
 * Learning path detail tabs. `value` is the `:page` URL segment; `subPage`
 * is the default `:subPage` for tabs that have their own sub navigation.
 */
export const PATH_TABS = [
  { value: 'mini-courses', label: 'Courses' },
  { value: 'landing-page', label: 'Landing page' },
  { value: 'settings', label: 'Settings', subPage: 'learner-authentication' },
  { value: 'learners', label: 'Learners' },
  { value: 'certification', label: 'Certification' },
  { value: 'analytics', label: 'Analytics' },
  { value: 'share', label: 'Share', subPage: 'url' },
]

/** Tabs a collaborator (non-owner) cannot open. */
export const OWNER_ONLY_TABS = ['settings', 'certification']

export const tabPath = (pathId, tab, subPage) =>
  `/collection/${pathId}/${tab}${subPage ? `/${subPage}` : ''}`
